// src/pages/RoleManagement/components/ColorPicker.tsx
// Color picker component for role group theme color

import React from 'react';
import { Row, Col, Label } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { PageActionPermission } from 'services/pageActionPermission/PageActionPermission';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('role_management');

interface ColorPickerProps {
  value?: string;
  onChange: (color: string) => void;
  disabled?: boolean;
}

const COLORS = [
  { name: st('tim_text'), value: '#7c3aed' },
  { name: st('xanh_duong_text'), value: '#1d4ed8' },
  { name: 'Xanh lam', value: '#0369a1' },
  { name: st('xanh_la_text'), value: '#047857' },
  { name: 'Cam', value: '#b45309' },
  { name: st('xam_text'), value: '#475569' },
];

const ColorPicker: React.FC<ColorPickerProps> = ({ value, onChange, disabled }) => {
  const location = useLocation();
  return (
    <div>
      <Label>{st('mau_chu_de_label')}</Label>
      <Row className="g-2">
        {COLORS.map((color) => (
          PageActionPermission.canDisplay(location.pathname, "input-color") && (
          <Col xs="auto" key={color.value}>
            <button
              type="button"
              className="btn p-0 border-0"
              style={{
                width: '48px',
                height: '48px',
                backgroundColor: color.value,
                border: value === color.value ? '3px solid #000' : '2px solid #e5e7eb',
                borderRadius: '8px',
                position: 'relative',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
              }}
              onClick={() => !disabled && onChange(color.value)}
              disabled={disabled}
              title={color.name}
              data-action-code="input-color"
              data-action-name="Màu nhóm quyền"
            >
              {value === color.value && (
                <i
                  className="ri-check-line"
                  style={{
                    color: 'white',
                    fontSize: '24px',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                ></i>
              )}
            </button>
          </Col>
          )
        ))}
      </Row>
    </div>
  );
};

export default ColorPicker;